import React from 'react';
import { LayoutInternal } from '@/layout';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { FormProvider } from 'react-hook-form';
import { FeedbackContainer, FormElement } from '@/features/forms/CrieSeuRoteiro/CrieSeuRoteiro.styles';
import { Banner } from '@/components/notification';
import { Button } from '@/components/button';
import FormContactType from '@/features/forms/FormContato/components/FormContactType/FormContactType';
import Checkbox from '@/components/form/Checkbox/Checkbox';
import { Grid } from '@/components/grid';
import Aside from '@/features/forms/FormContato/components/Aside/Aside';
import { useFormContatoContext } from '@/features/forms/FormContato/context';
import useFormMethods from './hooks/useFormMethods';
import { FormLoader } from '@/features/forms/components';
import FeedbackHandler from '@/features/forms/components/FeedbackHandler/FeedbackHandler';
import PageHeader from '@/components/typography/PageHeader/PageHeader';
import Text from '@/components/typography/Text/Text';
import { useTranslations } from 'next-intl';

const FormContato = () => {
  const t = useTranslations('FormContato');
  const { data } = useFormContatoContext();
  const { _token: token, page } = data;
  const breadcrumbs: BreadcrumbType = [{ text: page.title }];

  const { methods, onSubmit, feedback, submitted, submitting } = useFormMethods();

  return (
    <LayoutInternal breadcrumbs={breadcrumbs} navbar="sticky" footer="sticky" showWhatsAppDropup={false}>
      <Grid item col={12} col-sm={12} col-lg={8}>
        <WhitePaper>
          <PageHeader as="h1" title={page.title} description={page.summary || ''} />
          {submitted && (
            <>
              {/*added by: KTDEV-176*/}
              <FormLoader />
              {/*<Banner show={true} appearance="success" size="large">*/}
              {/*  <Text align="center" weight="bold">*/}
              {/*    Sua mensagem foi enviada com sucesso!*/}
              {/*  </Text>*/}
              {/*  <Text align="center" weight="bold">*/}
              {/*    Aguarde nosso contato.*/}
              {/*  </Text>*/}
              {/*</Banner>*/}
              {/*<Hr spacing="md" />*/}
              {/*<Text align="center">*/}
              {/*  <Button href="/" appearance="primary">*/}
              {/*    Voltar para Home*/}
              {/*  </Button>*/}
              {/*</Text>*/}
            </>
          )}

          {(submitting && <FormLoader />) ||
            (!submitted && (
              <FormProvider {...methods}>
                <FormElement
                  action="/proxy/action/form-contato"
                  method="post"
                  id="frmContato"
                  name="frmContato"
                  noValidate
                  onSubmit={methods.handleSubmit(onSubmit)}
                >
                  <FeedbackContainer>
                    <FeedbackHandler {...feedback} />
                    <Banner show={Object.keys(methods.formState.errors).length > 0} appearance="error" size="large">
                      <Text align="center" weight="bold">
                        {t('Por favor, corrigir o(s) erro(s) abaixo')}:
                      </Text>
                    </Banner>
                  </FeedbackContainer>
                  <input type="hidden" data-privacy="true" name="privacy_policy" value="1" />
                  <FormContactType />
                  <Checkbox
                    label={t('Gostaria de receber ofertas exclusivas por email?')}
                    {...methods.register('subscribeNews')}
                  />
                  <Button type="submit" appearance="primary" disabled={submitting}>
                    {t('ENVIAR SOLICITAÇÃO')}
                  </Button>
                </FormElement>
              </FormProvider>
            )) ||
            null}
        </WhitePaper>
      </Grid>
      <Grid item col={12} col-sm={12} col-lg={4} as="aside">
        <Aside />
      </Grid>
    </LayoutInternal>
  );
};

export default FormContato;
